export default "__VITE_ASSET__uOSkg6tV__"